import BaseAbstract from '@/abstract/BaseAbstract'
import IOService from '@/service/IOService'

class Service extends BaseAbstract {
  displayName = '分类'
  name = 'MallClassify'
  cacheDatas = []
  index () {
    return IOService.get('mall_classify')
      .then((res) => {
        this.cacheDatas = res.data
        return res
      })
  }

  store (params: object) {
    return IOService.post('mall_classify', params)
  }

  show (id: number) {
    return IOService.get(`mall_classify/${id}`)
  }

  update (params: { id: number }) {
    return IOService.put(`mall_classify/${params.id}`, params)
  }

  destroy (id: number | string) {
    return IOService.delete(`mall_classify/${id}`)
  }

  getList () {
    return Promise.resolve()
      .then(() => {
        if (this.cacheDatas.length === 0) {
          return this.index()
        }
      })
      .then(() => this.cacheDatas)
  }
}

export default new Service()
